import { Flex, Modal, Upload, Spin } from 'antd';
import './UploadAvatarModal.scss';
import { RcFile, UploadChangeParam } from 'antd/es/upload';

interface UploadAvatarModalProps {
  visible: boolean;
  onClose: () => void;
  onUpload: (file: RcFile) => boolean;
  onChange: (info: UploadChangeParam) => Promise<void>;
  isLoading?: boolean;
}

const UploadAvatarModal = ({ visible, onClose, onUpload, onChange, isLoading }: UploadAvatarModalProps) => {
  return (
    <Modal
      open={visible}
      footer={null}
      closable={false}
      maskClosable={true}
      onCancel={onClose}
      centered
      className="upload-avatar-modal"
    >
      <Flex vertical gap="55px" className="upload-avatar-modal__content">
        <h2 className="upload-avatar-modal__title">Upload a new profile photo</h2>
        <Upload
          showUploadList={false}
          beforeUpload={onUpload}
          multiple={false}
          onChange={onChange}
          accept=".jpg, .jpeg, .png, .heic"
        >
          {isLoading ? (
            <Spin size="large" className="upload-avatar-modal__spinner" />
          ) : (
            <button type="button" className="upload-avatar-modal__button">
              Choose a photo
            </button>
          )}
        </Upload>
      </Flex>
    </Modal>
  );
};

export default UploadAvatarModal;
